import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CorrectPracticeColor({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 60 60"
      width="60px"
      height="60px"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        fill="none"
        fillRule="evenodd"
        className={theme.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#003EA7"
      >
        <g
          id="correctcheckcolor"
          transform="translate(1.000000, 1.000000)"
          stroke="#003EA7"
        >
          <path
            d="M57.197,28.683 C57.197,12.935 44.431,0.169 28.683,0.169 C12.935,0.169 0.17,12.935 0.17,28.683 C0.17,44.431 12.936,57.197 28.684,57.197 C44.432,57.197 57.198,44.431 57.198,28.683 L57.197,28.683 Z"
            id="Path"
            fill="#FFFFFF"
          />
          <polygon
            id="Path"
            fill="#00B7BD"
            points="21.8 44 10.2 32.4 14.1 28.5 25.7 40.1"
          />
          <polygon
            id="Path"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="47.8 18 21.8 44 17.8 40 43.8 14"
          />
        </g>
      </g>
    </svg>
  )
}

CorrectPracticeColor.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
